// extracted by mini-css-extract-plugin
module.exports = {"opacityFadeIn":"MotionAnimations_opacityFadeIn__Ca3nR","fade-in":"MotionAnimations_fade-in__Qyngb"};